import { Pagination, History } from '@core/interface/core';

export class Employee {
  id!: number;
  name!: string;
  first_name!: string;
  last_name!: string;
  email!: string;
  employee_id!: number;
  manager_id!: number;
  payroll_no!: number;
  hourly_rate!: number;
  email_verified_at!: number;
  type!: number;
  status!: number;
  temporary_token!: string;
  created_at!: string | Date;
  updated_at!: string | Date;
  role_id!: number;
  login_invite!: number;
  role_name!: string;
  department_id!: number;
  company_id!: number;
  master_company_id?: number | null;
  is_shadow_engineer!: number;
  otp!: string;
  otp_expired_at!: string;
  gender!: string;
  date_of_birth!: string;
  national_insurance_number!: string;
  address!: string;
  employing_entity!: string;
  personal_email!: string;
  personal_phone_number!: string;
  manager_name!: string;
  company_name!: string;
  department_name!: string;
  file_sharing_role_id?: number | null;
  file_sharing_role?: { id: number; name: string } | string | null;
  user_id!: string;
  work_schedule_id!: string;
  employment_type_id!: string;
  work_location_id!: string;
  emergency_contact_name!: string;
  emergency_contact_number!: string;
  emergency_contact_nature_of_relationship!: string;
  start_date!: string;
  end_date!: string;
  tupe!: boolean;
  tupe_details!: string;
  hourly_rate_salary!: number;
  contracted_hours!: number;
  bonus_entitlement!: boolean;
  bonus_amount_or_percent!: number;
  holiday_allowance!: number;
  company_car_provided!: boolean;
  car_allowance_provided!: boolean;
  car_allowance_amount!: number;
  death_in_service!: boolean;
  death_in_service_multiple!: number;
  private_medical_insurance!: boolean;
  employer_pension_percent!: number;
  work_phone!: string;
  job_title!: string;
  label?: string;
  value?: number;
  history!: History[];
  attachments!: DocumentType[];
}
export class EmployeeCommonResponse {
  success!: boolean;
  message!: string;
}
export class EmployeeResponse extends EmployeeCommonResponse {
  data!: Employee[];
  pagination!: Pagination;
}
export class EmployeeError extends EmployeeCommonResponse {
  error?: any;
}
export class AddEmployeeResponse extends EmployeeCommonResponse {
  data!: Employee;
}
export class DeletedEmployee extends EmployeeCommonResponse {
  id!: number;
}

export class EmployeeByRoleResponse extends EmployeeCommonResponse {
  data!: EmployeeByRole[];
}

export class EmployeeByRole {
  id!: number;
  name!: string;
  role_name!: string;
  manager_name!: string;
  manager_id!: number;
}

export type RoleTypes = { [key in ROLES_NAME]: EmployeeByRole[] };

// Linked with ROLES_NAME
export enum ROLES {
  SUPER_ADMIN = 1,
  ADMIN = 2,
  CONTRACT_MANAGER = 3,
  ENGINEER = 4,
  HR_ADMINISTRATOR = 5,
}

export enum ROLES_NAME {
  SUPER_ADMIN = 'SUPER_ADMIN',
  ADMIN = 'ADMIN',
  CONTRACT_MANAGER = 'CONTRACT_MANAGER',
  ENGINEER = 'ENGINEER',
  HR_ADMINISTRATOR = 'HR_ADMINISTRATOR',
}

export class EmployeeProfile {
  id!: number;
  name!: string;
  first_name!: string;
  last_name!: string;
  email!: string;
  employee_id!: string;
  manager_id!: number;
  role_id!: number;
  login_invite!: number;
  payroll_no!: number;
  hourly_rate!: number;
  email_verified_at!: string | Date;
  type!: number;
  status!: number;
  temporary_token!: string;
  created_at!: string | Date;
  updated_at!: string | Date;
  role_name!: string;
  manager_name!: string;

  address!: string;
  attachments!: any[];
  bonus_amount_or_percent!: string;
  bonus_entitlement!: number;
  car_allowance_amount!: string;
  car_allowance_provided!: number;
  company_car_provided!: number;
  company_id!: number;
  company_name!: string;
  contracted_hours!: string;
  date_of_birth!: string;
  death_in_service!: number;
  death_in_service_multiple!: string;
  department_id!: number;
  department_name!: string;
  emergency_contact_name!: string;
  emergency_contact_nature_of_relationship!: string;
  emergency_contact_number!: string;
  employer_pension_percent!: string;
  employing_entity!: string;
  employment_type_id!: string;
  end_date!: string;
  gender!: string;
  holiday_allowance!: number;
  hourly_rate_salary!: string;
  is_shadow_engineer!: number;
  job_title!: string;
  national_insurance_number!: string;
  otp!: string;
  otp_expired_at!: string | Date;
  personal_email!: string;
  personal_phone_number!: string;
  private_medical_insurance!: number;
  start_date!: string;
  tupe!: number;
  tupe_details!: string;
  work_location_id!: string;
  work_phone!: string;
  work_schedule_id!: string;
  company_type!: number;
  default_company_id!: number;
  default_company_name!: string;
  file_sharing_role?: {
    id: number;
    name: string;
  } | null;
}

export class EmployeeProfileResposne extends EmployeeCommonResponse {
  data!: EmployeeProfile;
}

export class ChangePasswordPayload {
  current_password!: string;
  new_password!: string;
  confirm_password!: string;
}

export class EmployemntType {
  id!: number;
  name!: string;
  status!: number;
  is_deleted!: number;
  created_at!: string | Date;
  updated_at!: string | Date;
}

export class WorkScheduleType {
  id!: number;
  name!: string;
  status!: number;
  is_deleted!: number;
  created_at!: string | Date;
  updated_at!: string | Date;
}

export class WorkLocationType {
  id!: number;
  name!: string;
  status!: number;
  is_deleted!: number;
  created_at!: string | Date;
  updated_at!: string | Date;
}

export class TypeData {
  name!: string;
  status!: number;
  id?: number;
}

export class TypeResponse extends EmployeeCommonResponse {
  data!: EmployemntType[];
}
export class TypeUpdateResponse extends EmployeeCommonResponse {
  data!: EmployemntType;
}

export class DocumentType {
  id!: number;
  module_id!: number;
  name!: string;
  file_name!: string;
  attachment!: string;
  document_id!: number;
  module_type!: number;
  created_by!: number;
  updated_by!: number;
  created_at!: string | Date;
  updated_at!: string | Date;
  document_type_name!: string;
}
